import { render, staticRenderFns } from "./InitiativeDispatched.vue?vue&type=template&id=25d79490&scoped=true"
import script from "./InitiativeDispatched.vue?vue&type=script&lang=js"
export * from "./InitiativeDispatched.vue?vue&type=script&lang=js"
import style0 from "./InitiativeDispatched.vue?vue&type=style&index=0&id=25d79490&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d79490",
  null
  
)

export default component.exports